function DownArrow() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '4px 0' }}>
      <svg width="12" height="20" viewBox="0 0 12 20" aria-hidden="true">
        <path
          d="M6 0V16M6 16L2 12M6 16L10 12"
          stroke="#FF6B00" strokeWidth="1.5" fill="none"
          strokeLinecap="round" strokeLinejoin="round"
          opacity="0.35"
        />
      </svg>
    </div>
  )
}

export function ServerStack() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      {/* Step 1 */}
      <div style={{
        padding: '20px 22px', borderRadius: 14,
        background: '#f8f7f5', border: '1px solid #EDE9E4',
        display: 'flex', alignItems: 'center', gap: 14,
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: 10, background: '#E8E4DF',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 14, fontWeight: 700, color: '#6d6462',
        }}>1</div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700 }}>You call our API</div>
          <div style={{ fontSize: 12, color: '#777', marginTop: 2 }}>One endpoint. Three lines of code.</div>
        </div>
      </div>

      <DownArrow />

      {/* Step 2 */}
      <div style={{
        padding: '20px 22px', borderRadius: 14,
        background: '#FF6B00', color: '#fff',
        display: 'flex', alignItems: 'center', gap: 14,
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: 10,
          background: 'rgba(255,255,255,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 14, fontWeight: 700,
        }}>2</div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700 }}>We handle everything</div>
          <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>Queuing, routing, DKIM signing, retry logic — all on our infrastructure.</div>
        </div>
      </div>

      <DownArrow />

      {/* Step 3 */}
      <div style={{
        padding: '20px 22px', borderRadius: 14,
        background: '#f0fdf4', border: '1px solid #bbf7d0',
        display: 'flex', alignItems: 'center', gap: 14,
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: 10, background: '#22c55e',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontSize: 14, fontWeight: 700,
        }}>✓</div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#166534' }}>Lands in inbox</div>
          <div style={{ fontSize: 12, color: '#16a34a', marginTop: 2 }}>Not spam. Not promotions. Inbox.</div>
        </div>
      </div>

      <div style={{
        textAlign: 'center', fontSize: 11, color: '#777',
        fontFamily: "var(--oe-font-mono)", marginTop: 14,
        padding: '8px 14px', background: '#f8f7f5', borderRadius: 8,
      }}>
        Under 2 seconds, end-to-end
      </div>
    </div>
  )
}
